import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  return (
    <Row
      style={{
        justifyContent: "center",
        paddingBottom: "10px",
        color: "white",
      }}
    >
      <h1 className="project-heading pb-4" style={{ paddingBottom: "20px" }}>
        The Days I <strong className="purple">Code</strong>
      </h1>
      <GitHubCalendar
        username="nawfal8815"
        blockSize={30}
        blockMargin={10}
        color="#14FFEC"
        fontSize={20}
      />
    </Row>
  );
}

export default Github;